'use client';
import * as React from "react";
import { renderDrawerFooter_unstable } from "@fluentui/react-drawer";
import { useCustomStyleHook_unstable } from "@fluentui/react-shared-contexts";
import { useNavDrawerFooter_unstable } from "./useNavDrawerFooter.js";
import { useNavDrawerFooterStyles_unstable } from "./useNavDrawerFooterStyles.styles.js";
/**
 * NavDrawerFooter component
 */ export const NavDrawerFooter = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useNavDrawerFooter_unstable(props, ref);
    useNavDrawerFooterStyles_unstable(state);
    useCustomStyleHook_unstable('useNavDrawerFooterStyles_unstable')(state);
    return renderDrawerFooter_unstable(state);
});
NavDrawerFooter.displayName = 'NavDrawerFooter';
